
export type PieceCode = "p" | "r" | "n" | "b" | "q";

export const pieceNameMap: Record<PieceCode, string> = {
  p: "pawn",
  r: "rook",
  n: "knight",
  b: "bishop",
  q: "queen",
};

export function getPieceCounts(piecesArray: PieceCode[]): Record<PieceCode, number> {
  return piecesArray.reduce((acc, piece) => {
    acc[piece] = (acc[piece] || 0) + 1;
    return acc;
  }, {} as Record<PieceCode, number>);
}
